/**
 * Mega menu: altezza uniforme.
 * Misura il pannello mega menu più alto e applica quella min-height a tutti,
 * così l'altezza non "salta" passando da un menu all'altro.
 * Solo desktop (>= 990px, dove il mega menu è a tendina). Si ri-applica al
 * resize. Nessun valore fisso da mantenere: si adatta se cambiano le voci.
 */
(function () {
  'use strict';

  var DESKTOP = window.matchMedia('(min-width: 990px)');

  function panels() {
    return Array.prototype.slice.call(
      document.querySelectorAll(
        '.header__nav-item.megamenu .header__nav-dropdown.js-dropdown'
      )
    );
  }

  function inner(panel) {
    return panel.querySelector('.header__nav-dropdown-inner');
  }

  function equalize() {
    var list = panels();
    if (!list.length) return;

    // 1) reset: togli eventuale min-height precedente prima di rimisurare
    list.forEach(function (p) {
      var box = inner(p);
      if (box) box.style.minHeight = '';
    });

    // Sotto i 990px il mega menu non è a tendina: niente uniformazione.
    if (!DESKTOP.matches) return;

    // 2) misura l'altezza naturale di ogni pannello senza mostrarlo
    var max = 0;
    var boxes = list
      .map(function (p) {
        var box = inner(p);
        if (!box) return null;
        var prevDisplay = p.style.display;
        var prevVisibility = p.style.visibility;
        // il pannello è position:absolute quindi non sposta il layout
        p.style.visibility = 'hidden';
        p.style.display = 'block';
        var h = box.offsetHeight;
        p.style.display = prevDisplay;
        p.style.visibility = prevVisibility;
        if (h > max) max = h;
        return box;
      })
      .filter(Boolean);

    // 3) applica la min-height del più alto a tutti
    if (max > 0) {
      boxes.forEach(function (box) {
        box.style.minHeight = max + 'px';
      });
    }
  }

  var raf;
  function onResize() {
    if (raf) cancelAnimationFrame(raf);
    raf = requestAnimationFrame(equalize);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', equalize);
  } else {
    equalize();
  }
  // i font/immagini possono cambiare l'altezza: rimisura a load
  window.addEventListener('load', equalize);
  window.addEventListener('resize', onResize);
  if (DESKTOP.addEventListener) {
    DESKTOP.addEventListener('change', equalize);
  } else if (DESKTOP.addListener) {
    DESKTOP.addListener(equalize);
  }
})();
